import { initParallax } from 'allink-core-static/js/modules/parallax';

$(function(){

    var options = {
        // updateCallback: function($gallery, difference, scrollProgress){},
        // reversed: false, // boolean
    };

    // on page load
    initParallax(options);

    // custom event
    $(window).on('initParallax', function(options) {
        initParallax(options);
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/parallax.js